import React from 'react';
import get from 'lodash/get';
import { analytics } from '@atlassian/temp-analytics';
import { useApplicationContext } from '@css-xp/base';
import { useParams } from 'react-router-dom';
import { PartnerAccount } from '@css-xp/ppc-types';
import { useLocalStorage } from 'usehooks-ts';

export interface EventAttributes {
  [k: string]: boolean | string | number | string[] | null | undefined;
}

interface ScreenEvent {
  name: string;
  attributes?: EventAttributes;
}

interface ScreenEventAnalyticsProps {
  event: ScreenEvent;
  isFetching?: boolean;
}

export const ScreenEventAnalytics = (props: ScreenEventAnalyticsProps) => {
  const { event, isFetching = false } = props;
  const [hasSentEvent, setSentEvent] = React.useState(false);

  const user = useApplicationContext();
  const [txaId] = useLocalStorage(`${user?.atlassianAccountId}-selectedTxa`, '');

  const partnerAccounts = user.partnerAccounts;

  const selectedPartnerAccount = partnerAccounts?.find(
    (partnerAccount: PartnerAccount) => partnerAccount.transactionAccountId === txaId
  );
  event.attributes = {
    ...event.attributes,
    userData: `${user.atlassianAccountId} ( ${get(selectedPartnerAccount, 'name', '')} )`,
    transactionAccountId: txaId,
  };

  const sendAnalyticsIfLoaded = React.useCallback(() => {
    if (hasSentEvent || isFetching) {
      return;
    }

    analytics.setGlobalPageProperties({
      source: event.name,
      pageAttributes: event.attributes,
    });

    analytics.sendScreenEvent(event);
    setSentEvent(true);
  }, [event, hasSentEvent, isFetching]);

  React.useEffect(() => {
    sendAnalyticsIfLoaded();
  }, [isFetching, sendAnalyticsIfLoaded]);

  return <></>;
};
